import { DashboardDateRangePickerTypesEnum } from '@features/dashboard/constants';

import theme, { blue8, orange10, pink40 } from '../../../themes/colors';

export const STEPPER_CONSTANTS = {
  COLORS: {
    PENDING_BG: theme.grey40,
    COMPLETED_BG: theme.primaryLiteBg,
    CONNECTING_LINE_ACTIVE: theme.verifiedGreen,
    CONNECTING_LINE_INACTIVE: theme.grey40
  }
} as const;

export enum LeadStatus {
  NOT_STARTED = 'Not started',
  IN_PROGRESS = 'In Progress',
  UNDER_REVIEW = 'Under Review',
  APPROVED = 'Approved',
  CONVERTED = 'Converted',
  CLOSED = 'Closed'
}

export enum StepStatus {
  COMPLETED = 'Completed',
  CURRENT = 'Current',
  PENDING = 'Pending'
}
export enum LeadSource {
  FACEBOOK_ADS = 'facebook_ads',
  FACEBOOK_DM = 'facebook_dm',
  INSTAGRAM_DM = 'instagram_dm',
  WHATSAPP = 'whatsapp',
  CALL = 'call',
  REFERRAL = 'referral',
  OTHERS = 'others',
  WEBSITE = 'website',
  NEWSPAPER = 'newspaper'
}

export enum Fields {
  STATUS = 'status',
  SOURCE = 'source',
  ASSIGNEE = 'assignee',
  LEADS = 'leads'
}

export enum LeadSectionId {
  TAGS = 'tags',
  ASSIGNEES = 'assignees',
  STATUS = 'status',
  LEADS = 'leads'
}

export const getRandomColor = (index?: number) => {
  const colorsArray = [blue8, pink40, orange10];

  const colorIndex =
    (index || Math.floor(Math.random() * colorsArray.length)) %
    colorsArray.length;

  return colorsArray[colorIndex];
};

export const leadSourceColorMap: Record<string, string> = {
  [LeadSource.WHATSAPP]: '#94E9B8',
  [LeadSource.FACEBOOK_ADS]: '#188AEC',
  [LeadSource.FACEBOOK_DM]: '#92BFFF',
  [LeadSource.WEBSITE]: '#EBD667',
  [LeadSource.INSTAGRAM_DM]: '#C6A0E9',
  [LeadSource.CALL]: '#E97451',
  [LeadSource.REFERRAL]: '#30B474',
  [LeadSource.OTHERS]: '#ABB1B7'
};

export const dateRangeMap = {
  [DashboardDateRangePickerTypesEnum.thisMonth]: 'this_month',
  [DashboardDateRangePickerTypesEnum.lastMonth]: 'last_month',
  [DashboardDateRangePickerTypesEnum.custom]: 'custom'
};

export const leadDashabordTabFiltersOptions = [
  { id: 'count', label: 'Count' },
  { id: 'revenue', label: 'Revenue' }
];

export const leadSourceOptions = {
  [LeadSource.FACEBOOK_ADS]: 'Facebook Ads',
  [LeadSource.FACEBOOK_DM]: 'Facebook DMs',
  [LeadSource.INSTAGRAM_DM]: 'Instagram DMs',
  [LeadSource.WHATSAPP]: 'WhatsApp',
  [LeadSource.CALL]: 'Call',
  [LeadSource.REFERRAL]: 'Referral',
  [LeadSource.OTHERS]: 'Others',
  [LeadSource.WEBSITE]: 'Website',
  [LeadSource.NEWSPAPER]: 'Newspaper'
};
